import { DefaultTheme, styled } from 'styled-components';
interface LinkButtonProps {
  $margin?: string;
  $fontSize?: string;
  $color?: keyof DefaultTheme['colors'];
}
export const LinkButton = styled.button<LinkButtonProps>(
  ({ theme, $fontSize, $color = 'helsinkiBlue' }) => `
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  cursor: pointer;
  outline: none;
  color:  ${theme.colors[$color]};
  text-decoration: underline;
  font-size: ${$fontSize};

  &[disabled] {
    cursor: not-allowed;
    background-color: ${theme.colors.grayLight};
  }
  
  &:focus-visible {
    outline: 2px solid ${theme.colors.focusOutline};
  }
  `,
);
